<template>
  <van-popup
    v-model="show"
    class="HowToSearchPopup"
    @close="close"
  >
    <div class="content">
      <how-to-search-main-card v-bind="$attrs" v-on="$listeners"></how-to-search-main-card>
      <!-- <van-button type="info" round size="normal" class="copyKeyWard" @click="$emit('copyKeyWard')">
        复制口令
      </van-button> -->
    </div>
  </van-popup>
</template>

<script>
import { Popup, Button } from "vant";
import HowToSearchMainCard from "./components/HowToSearchMainCard";
export default {
  name: "SouhuoH5Howtosearch",

  data() {
    return {
      show: false,
    };
  },

  props: {
    // 是否展示弹窗
    isShow: {
      type: Boolean,
      default: () => {
        return false;
      },
    }
  },

  watch: {
    isShow(val) {
      this.show = val;
    },
  },

  components: {
    "how-to-search-main-card": HowToSearchMainCard,
    "van-popup": Popup,
    "van-button": Button
  },

  mounted() {},

  methods: {
    // 关闭
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.HowToSearchPopup {
  background-color: transparent;
  width: 90%;
  overflow-y: visible;
  .content {
    position: relative;
    width: 100%;
    .copyKeyWard {
      position: absolute;
      left: 50%;
      transform: translate(-50%, 40px);
    }
  }
}
</style>